<template>
  <svg width="30" height="20" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="4" width="20" height="15" rx="1" stroke="#243746" stroke-width="2"/>
    <rect x="4" y="4" width="14" height="15" stroke="#243746" stroke-width="2"/>
    <rect x="7" y="1" width="8" height="3" stroke="#243746" stroke-width="2"/>
    <path d="M25 11H29V18C29 18.5523 28.5523 19 28 19H26C25.4477 19 25 18.5523 25 18V11Z" stroke="#243746" stroke-width="2"/>
    <path d="M27 10.0003V4.16699" stroke="#243746" stroke-width="2"/>
    <path d="M25.3333 0H28.6667L29 5H25L25.3333 0Z" fill="#243746"/>
  </svg>
</template>
